import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataCountryListService = (
  params: Types.MasterDataCountryListRequest
) =>
  RestAPIClient.call<Types.MasterDataCountryListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const masterDataCountryListShortService = (
  params: Types.MasterDataCountryListRequest
) =>
  RestAPIClient.call<Types.MasterDataCountryListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });
